import { CheckCircle, XCircle, FileText, Hourglass } from "lucide-react";
import DashboardCount from "../dashboardCount/DashboardCount";
import { useSelector } from "react-redux";
import LabelField from "../Form/FormFields/LabelField";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import Accordion from "../ui/Accordion";
import NoteComponent from "../ui/table/Notes";
import { dashboardNotes } from "../Form/text";

function RuralDetailsCount({ ...props }) {
  const propsData = props?.chartListData;

  interface DynamicData {
    [key: string]: Array<{
      opening_balance: number;
      received: number;
      approved: number;
      rejected: number;
      loading: number;
    }>;
  }

  const selectorData = useSelector(
    (state: { dynamicData: DynamicData }) => state?.dynamicData
  );

  // Check if chart_value exists in props (pre-loaded data)
  const hasChartValue =
    propsData?.chart_value && propsData.chart_value.length > 0;

  // Use chart_value from props if available, otherwise use Redux selector data
  const chartData = hasChartValue
    ? propsData.chart_value
    : selectorData[propsData?.id];
  const notes = propsData?.note;
  const notesData = propsData?.remarks;

  // Only show loading when fetching from API (no chart_value in props)
  const isLoading =
    !hasChartValue && selectorData.loaders[`report/chart/${[propsData?.id]}`];

  return (
    <>
      <div className={`grid gap-3 ${props.width && props.width} bg-red-50`}>
        <div className=" p-4 rounded-lg  w-full bg-white">
          <div className="flex justify-between items-center ">
            <h2 className="text-lg font-semibold mb-2 flex items-center">
              <LabelField label={propsData?.title} />
              {notes ? <NoteComponent notes={notesData} modalTitle={propsData?.title}/> : null}
            </h2>
          </div>

          {isLoading ? (
            <DynamicLoader loading={isLoading} />
          ) : (
            <>
              <DashboardCount data={chartData} />
            </>
          )}
          {!propsData.chart_value && (
            <div className="mt-9">
              <Accordion
                title="AI Insights"
                componentID={propsData?.id}
                chartData={propsData}
                chartValue={chartData}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RuralDetailsCount;
